import { render, staticRenderFns } from "./EmergencyMessageAlert.vue?vue&type=template&id=28055780&scoped=true"
import script from "./EmergencyMessageAlert.vue?vue&type=script&lang=js"
export * from "./EmergencyMessageAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28055780",
  null
  
)

export default component.exports